/**
 * Aliases default de customer (name/id + CSS).
 *
 * Cobre BuyGoods (`emailaddress`, `creditcards_*`, `addresses_*`),
 * checkout interno CardioClear/SlimSoda (`#email`, `address1`, `#addr`)
 * e CoreStrength (`address1`, `billing_address1`, `billing_postal_code`).
 *
 * Sempre somam — `commerce.customer.fields` só adiciona, nunca substitui.
 */

export const DEFAULT_EMAIL_FIELDS = [
  'email',
  'emailaddress',
  'customerEmail',
  'customer_email',
  'e-mail',
  'email_address',
  'emailAddress',
  '#email',
  '#emailaddress',
] as const;

export const DEFAULT_PHONE_FIELDS = [
  'phone',
  'telefone',
  'tel',
  'customerPhone',
  'customer_phone',
  'celular',
  'mobile',
  'phone_number',
  'phoneNumber',
  'phonenumber',
  '#phone',
] as const;

export const DEFAULT_NAME_FIELDS = [
  'name',
  'nome',
  'fullName',
  'full_name',
  'fullname',
  'billing_name',
  'creditcards_name',
  'addresses_name',
  'shipping_name',
  '#creditcards_name',
  '#addresses_name',
] as const;

export const DEFAULT_FIRST_NAME_FIELDS = [
  'firstName',
  'first_name',
  'firstname',
  'first-name',
  'fname',
  'primeiro',
  'primeiro_nome',
  'given-name',
  '#first_name',
] as const;

export const DEFAULT_LAST_NAME_FIELDS = [
  'lastName',
  'last_name',
  'lastname',
  'last-name',
  'lname',
  'sobrenome',
  'family-name',
  '#last_name',
] as const;

export const DEFAULT_ADDRESS_FIELDS = [
  'address',
  'street',
  'street_address',
  'billing_address',
  'shipping_address',
  'endereco',
  'address1',
  'address_1',
  'billing_address1',
  'shipping_address1',
  'creditcards_address',
  'addresses_address',
  'addr',
  '#address1',
  '#addr',
  '#creditcards_address',
  '#addresses_address',
  '#billing_address1',
] as const;

export const DEFAULT_ADDRESS2_FIELDS = [
  'address2',
  'address_2',
  'apt',
  'apartment',
  'suite',
  'complement',
  'complemento',
  'billing_address2',
  'shipping_address2',
  'addr2',
  '#address2',
  '#addr2',
  '#billing_address2',
] as const;

export const DEFAULT_CITY_FIELDS = [
  'city',
  'cidade',
  'billing_city',
  'shipping_city',
  'creditcards_city',
  'addresses_city',
  '#city',
  '#creditcards_city',
  '#addresses_city',
  '#billing_city',
] as const;

export const DEFAULT_STATE_FIELDS = [
  'state',
  'estado',
  'region',
  'billing_state',
  'shipping_state',
  'creditcards_state',
  'addresses_state',
  'state_intl',
  '#state',
  '#state_intl',
  '#creditcards_state',
  '#addresses_state',
  '#billing_state',
] as const;

export const DEFAULT_ZIP_FIELDS = [
  'postalCode',
  'postal_code',
  'postal',
  'zip',
  'zipcode',
  'zip_code',
  'cep',
  'billing_zip',
  'billing_postal_code',
  'shipping_zip',
  'shipping_postal_code',
  'creditcards_zip',
  'addresses_zip',
  '#postal_code',
  '#zip',
  '#creditcards_zip',
  '#addresses_zip',
  '#billing_postal_code',
] as const;

export const DEFAULT_COUNTRY_FIELDS = [
  'country',
  'pais',
  'billing_country',
  'country_code',
  'shipping_country',
  'creditcards_country',
  'addresses_country',
  '#country',
  '#creditcards_country',
  '#addresses_country',
  '#billing-country',
  '#billing_country',
] as const;
